import React from 'react';

const TableNavigateIcon: React.FC = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.66669 7.83288L14.1334 2.36621"
      stroke="#00A389"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6667 5.03301V1.83301H11.4667"
      stroke="#00A389"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.33331 1.83301H5.99998C2.66665 1.83301 1.33331 3.16634 1.33331 6.49967V10.4997C1.33331 13.833 2.66665 15.1663 5.99998 15.1663H9.99998C13.3333 15.1663 14.6666 13.833 14.6666 10.4997V9.16634"
      stroke="#00A389"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TableNavigateIcon;
